import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  h1: {
    margin: "24px 0 24px",
  },
  h2: {
    margin: "24px 0 24px",
  },
  h3: {
    margin: "18px 0 18px",
  },
  h4: {
    margin: "16px 0 16px",
  },
  h5: {
    margin: "14px 0 14px",
  },
  h6: {
    margin: "12px 0 12px",
  },
});

export const H1 = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h1" component="h1" className={classes.h1}>
      {children}
    </Typography>
  );
};

export const H2 = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h2" component="h2" className={classes.h2}>
      {children}
    </Typography>
  );
};

export const H3 = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h3" component="h3" className={classes.h3}>
      {children}
    </Typography>
  );
};

export const H4 = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h4" component="h4" className={classes.h4}>
      {children}
    </Typography>
  );
};

export const H5 = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h5" component="h5" className={classes.h5}>
      {children}
    </Typography>
  );
};
export const H6 = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h6" component="h6" className={classes.h6}>
      {children}
    </Typography>
  );
};
